export function shouldDiscardPhoneCallOnPageUnload(state: string | undefined): boolean {
  if (!state) {
    return false;
  }

  return state === 'accepted' || state === 'active' || state === 'discarded';
}
